import { z } from 'zod';
import { stringArraySchema, timestampSchema } from './shared';

export const mediaTypeEnum = z.enum(['image', 'video', 'audio']);

export const mediaRowSchema = z.object({
  id: z.string().min(1),
  type: mediaTypeEnum,
  filename: z.string().min(1),
  url: z.string().min(1),
  size: z.number().int().nonnegative(),
  usedIn: stringArraySchema.nullable(),
  uploadedAt: timestampSchema,
  // Accessibility / SEO alt text. Nullable in the DB; optional on the wire so
  // pre-migration cached rows still validate.
  altText: z.string().nullable().optional(),
});

// POST /api/media/upload response. Identical shape to mediaRowSchema today,
// but kept separate so wire-only side-effects (e.g., a signed URL) can diverge
// without churning the row schema.
export const mediaUploadResponseSchema = mediaRowSchema;

export type MediaRow = z.infer<typeof mediaRowSchema>;
export type MediaUploadResponse = z.infer<typeof mediaUploadResponseSchema>;
